import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import NewsFeedPreview from './js/news-feed-preview.component';

ComponentsFactory.getInstance().define('news-feed-preview', NewsFeedPreview);
